// src/i18n/es/metricLabels.ts
// Nombre de cada indicador v2 en español, keyed by the stable metric id the
// API sends (`MetricResultDto.id`, e.g. `ops.arrivals` -> metrics.ops.arrivals).
// The API's own `label` is only the fallback for an id missing here.
export const metricLabels = {
  chain: {
    arrivals: 'Llegadas',
    self_service_completed: 'Completadas en autoservicio',
    containment: 'Resueltas sin recepción',
    time_to_key_median: 'Tiempo de entrega de la llave (mediana)',
    incidents: 'Incidencias',
    availability: 'Disponibilidad de dispositivos Roommatik',
    stall_step: 'Paso donde más se abandona',
    pre_checkin_share: 'Llegadas con pre-check-in',
    median: 'Mediana de la cadena',
    properties_with_rates: 'Hoteles con datos',
    ranking: 'Clasificación por llegadas resueltas sin recepción',
    config_chapter: 'Configuraciones que funcionan mejor en hoteles como el suyo',
    mobile_key_adoption: 'Llaves móviles: estancias con llave móvil (cadena)',
  },
  ops: {
    arrivals: 'Llegadas',
    arrivals_rooms: 'Habitaciones de llegada',
    self_service_completed: 'Autoservicio completado',
    completed_without_key: 'Completadas sin llave',
    containment: 'Resueltas sin recepción',
    awaiting_pms_confirmation: 'Pendientes de confirmación del sistema de reservas',
    checked_in_by_staff: 'Check-ins realizados por el personal',
    arrivals_by_end_state: 'Llegadas del día por estado al cierre',
    self_service_incomplete_then_checked_in: 'Terminadas en recepción tras un intento en autoservicio',
    time_to_key_median: 'Tiempo de entrega de la llave',
    time_to_key_p90: 'Tiempo de entrega de la llave (9 de cada 10)',
    journey_duration_median: 'Duración del trayecto',
    incidents: 'Incidencias',
    journeys_started: 'Trayectos iniciados',
    journeys_by_outcome: 'Trayectos por resultado',
    completion_rate: 'Tasa de finalización',
    handed_to_desk: 'Enviados a recepción',
    abandon_reasons: 'Motivos de abandono',
    step_funnel: 'Embudo por paso',
    stall_share: 'Punto de abandono',
    time_on_step_median: 'Tiempo por paso',
    attempt_fallback: 'Identificación: de escaneo a manual',
    errors_by_component: 'Errores por componente',
    error_rate: 'Trayectos con error',
    pre_checkin_share: 'Llegadas con pre-check-in',
    pre_checkin_funnel: 'Pre-check-in en línea',
    pre_checkin_resumed: 'Pre-check-in retomados',
    keys_issued: 'Llaves emitidas',
    key_failures: 'Fallos de emisión de llave',
    walkins: 'Walk-in',
    three_sentences: 'Tres cosas que han cambiado',
    mobile_key_adoption: 'Llaves móviles: estancias con llave móvil',
    ces: 'Facilidad percibida (media de 1 a 5)',
  },
  board: {
    pending: 'Pendientes',
    at_device: 'En el kiosco',
    needs_help: 'Necesitan a alguien',
    room_not_ready: 'Esperando habitación (habitación no lista)',
    awaiting_pms_confirmation: 'Pendientes de confirmación del sistema de reservas',
    today_so_far: 'Hoy hasta ahora',
    device_strip: 'Dispositivos',
    incidents_open: 'Incidencias abiertas',
    errors_now: 'Trayectos con error ahora',
  },
  fin: {
    payments_accepted: 'Cobros aceptados en autoservicio',
    payments_declined: 'Cobros rechazados o fallidos',
    payments_posted: 'Confirmado por el kiosco',
    payment_unreconciled: 'Cobros sin confirmar',
    orphaned: 'Importes huérfanos',
    refunds: 'Devoluciones',
    reconciliation_rate: 'Tasa de conciliación',
    cash_handled: 'Efectivo',
    tourist_tax: 'Tasa turística cobrada',
  },
  it: {
    availability: 'Disponibilidad',
    unknown_share: 'Tiempo sin señal',
    silent_devices: 'Dispositivos sin señal',
    down_time: 'Tiempo de parada',
    incidents: 'Incidencias',
    time_to_resolve_median: 'Tiempo de resolución',
    time_to_acknowledge_median: 'Tiempo hasta el reconocimiento',
    detection_lag: 'Retardo de detección',
    peripheral_faults: 'Averías por periférico',
    consumables_low: 'Consumibles bajos',
    pms_link: 'Conexión con el sistema de reservas',
    feed_freshness: 'Antigüedad de los datos de reservas',
    reconciliation_gap: 'Discrepancias con el sistema de reservas',
    unmatched_journeys: 'Trayectos sin reserva en los datos recibidos',
    ingest_gaps: 'Huecos en la recepción de datos',
    rejected_events: 'Eventos rechazados',
    software_versions: 'Versiones desplegadas',
    remote_sessions: 'Sesiones remotas',
    mode_changes: 'Cambios de modo',
  },
  fit: {
    completion_rate: 'Tasa de finalización por versión y configuración',
    time_on_step: 'Tiempo por paso por versión',
    time_to_key: 'Tiempo de entrega de la llave por versión',
    attempts_per_step: 'Intentos por paso',
    first_attempt_success: 'Éxito al primer intento por método',
    method_fallback: 'Cambio de método',
    step_error_rate: 'Errores por paso',
    stall_share: 'Punto de abandono por versión',
    backtrack_share: 'Retrocesos por paso',
    skip_consistency: 'Saltos de paso por motivo',
    language_share: 'Sesiones por idioma',
    ces: 'Facilidad percibida por versión y configuración (media de 1 a 5)',
  },
};

export default metricLabels;
